import Vue from 'vue'
import 'normalize.css/normalize.css'
import '@/assets/fonts/font.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' 
import VCharts from 'v-charts'
import '@/styles/index.scss'

import App from './App'
import router from './router'
import store from './store'

import '@/icons' 
import '@/permission' 
// import '@/utils/errorHandler'

Vue.use(ElementUI, { locale })
Vue.use(VCharts)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js